import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "./client";
import { creditsAvailableQueryKey } from "./queryKeys";

function transformCredits(response) {
  const available = response.available_credits || 0;
  return { qualCredits: available.qual_credits_remaining, certCredits: available.cert_credits_remaining };
}

export function useGetCreditsAvailable(options = {}) {
  return useQuery({
    queryKey: creditsAvailableQueryKey,
    queryFn: () => apiFetch("/extras/api/v2/usage/available"),
    select: transformCredits,
    ...options,
  });
}
